import { all, call, fork, takeEvery } from "redux-saga/effects";
import requestFunction from "../../Utils/sagaGenericFunction";
import {
  getUserWalletSuccess,
  getUserWalletFailure,
  createFundingIntentSuccess,
  createFundingIntentFailure,
  initializeFundingPaymentSuccess,
  initializeFundingPaymentFailure,
  verifyFundingPaymentSuccess,
  verifyFundingPaymentFailure,
  getWalletHistorySuccess,
  getWalletHistoryFailure,
  getAdminWalletHistorySuccess,
  getAdminWalletHistoryFailure,
  processWalletRefundSuccess, // 👉 Import new Refund
  processWalletRefundFailure,
  processWalletRewardSuccess, // 👉 Import new Reward
  processWalletRewardFailure,
  getCustomerWalletsSuccess,
  getCustomerWalletsFailure,
} from "../Actions/walletAction";
import {
  GET_USER_WALLET,
  CREATE_FUNDING_INTENT,
  INITIALIZE_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT,
  GET_WALLET_HISTORY,
  GET_ADMIN_WALLET_HISTORY,
  PROCESS_WALLET_REFUND, // 👉 Import Action Types
  PROCESS_WALLET_REWARD,
  GET_CUSTOMER_WALLETS,
} from "../ActionTypes";
import {
  GetUserWalletApi,
  CreateFundingIntentApi,
  InitializeFundingPaymentApi,
  VerifyFundingPaymentApi,
  GetWalletHistoryApi,
  GetAdminWalletHistoryApi,
  ProcessWalletRefundApi, // 👉 Import APIs
  ProcessWalletRewardApi,
  GetCustomerWalletsApi,
} from "../Api";

const getUserWalletWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getUserWalletSuccess,
    getUserWalletFailure,
    GetUserWalletApi,
    payload,
  );
};
const getCustomerWalletsWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getCustomerWalletsSuccess,
    getCustomerWalletsFailure,
    GetCustomerWalletsApi,
    payload,
  );
};

const createFundingIntentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    createFundingIntentSuccess,
    createFundingIntentFailure,
    CreateFundingIntentApi,
    payload,
  );
};

const initializeFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    initializeFundingPaymentSuccess,
    initializeFundingPaymentFailure,
    InitializeFundingPaymentApi,
    payload,
  );
};

const verifyFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    verifyFundingPaymentSuccess,
    verifyFundingPaymentFailure,
    VerifyFundingPaymentApi,
    payload,
  );
};

const getWalletHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getWalletHistorySuccess,
    getWalletHistoryFailure,
    GetWalletHistoryApi,
    payload,
  );
};

const getAdminWalletHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAdminWalletHistorySuccess,
    getAdminWalletHistoryFailure,
    GetAdminWalletHistoryApi,
    payload,
  );
};

// 👉 NEW: Refund Worker
const processWalletRefundWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    processWalletRefundSuccess,
    processWalletRefundFailure,
    ProcessWalletRefundApi,
    payload,
  );
};

// 👉 NEW: Reward Worker
const processWalletRewardWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    processWalletRewardSuccess,
    processWalletRewardFailure,
    ProcessWalletRewardApi,
    payload,
  );
};

export const getUserWalletWatcher = function* () {
  yield takeEvery(GET_USER_WALLET, getUserWalletWorker);
};

export const fundingSagas = function* () {
  yield takeEvery(CREATE_FUNDING_INTENT, createFundingIntentWorker);
  yield takeEvery(INITIALIZE_FUNDING_PAYMENT, initializeFundingPaymentWorker);
  yield takeEvery(VERIFY_FUNDING_PAYMENT, verifyFundingPaymentWorker);
};

export const walletHistorySaga = function* () {
  yield takeEvery(GET_WALLET_HISTORY, getWalletHistoryWorker);
  yield takeEvery(GET_ADMIN_WALLET_HISTORY, getAdminWalletHistoryWorker);
};

// 👉 NEW: Watcher for admin wallet actions
export const walletAdminActionsSaga = function* () {
  yield takeEvery(PROCESS_WALLET_REFUND, processWalletRefundWorker);
  yield takeEvery(PROCESS_WALLET_REWARD, processWalletRewardWorker);
  yield takeEvery(GET_CUSTOMER_WALLETS, getCustomerWalletsWorker);
};

export default function* walletSaga() {
  yield all([
    fork(getUserWalletWatcher),
    fork(fundingSagas),
    fork(walletHistorySaga),
    fork(walletAdminActionsSaga), // 👉 Add new fork
  ]);
}
